module.exports = __webpack_public_path__ + "img/wlogo.c575a1fe.svg";